<template>
    <div>
        <el-upload
                :action="baseUrl + '/api/image'"
                :headers="headers"
                name="image"
                :file-list="fileList"
                list-type="picture-card"
                :multiple="false"
                :limit="1"
                :on-success="fileUploaded"
                :before-remove="confirmRemove"
                :on-remove="removeImage">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
    import imageAPI from "../mixins/api/imageAPI";


    export default {
        props: {
            image: {
                type: String,
                required: false,
            }
        },
        mixins: [imageAPI],

        data() {
            return {
                dialogImageUrl: '',
                dialogVisible: false,
                headers: {
                    Authorization: localStorage.getItem('Authorization')
                },
                baseUrl: process.env.VUE_APP_ROOT_API,
            };
        },
        methods: {
            confirmRemove() {
                return this.$confirm('Remove this image?', 'Remove image', {
                    confirmButtonText: 'Remove',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                });
            },

            async removeImage(file, fileList) {
                try {
                    const response = await this.imageAPI_delete(this.image);
                    console.log('delete response', response);
                    this.$emit('delete');
                } catch (err) {
                    console.log(err);
                }
            },

            fileUploaded(response, file, fileList) {
                console.log(response);
                 this.$emit('upload', response.fileName);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
        },

        computed: {
            fileList() {
                if(!this.image || this.image == '') {
                    return [];
                } else {
                    return [{ name: this.image, url: this.$imgix(this.image, 200) }];
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue